module.exports = __webpack_public_path__ + "src/assets/fonts/Mohaji-Icons.04abb7.woff";